export default "__VITE_ASSET__CHt$ntzc__"